import React from "react";

const Pen: React.FC<{ width?: number; height?: number; color?: string }> = ({
  width = 20,
  height = 20,
  color = "currentColor",
}) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" id="icon" width={width} height={height} viewBox="0 0 32 32">
      <rect fill={color} xmlns="http://www.w3.org/2000/svg" x="2" y="26" width="28" height="2" />
      <path
        fill={color}
        xmlns="http://www.w3.org/2000/svg"
        d="M25.4,9c0.8-0.8,0.8-2,0-2.8c0,0,0,0,0,0l-3.6-3.6c-0.8-0.8-2-0.8-2.8,0c0,0,0,0,0,0l-15,15V24h6.4L25.4,9z M20.4,4L24,7.6  l-3,3L17.4,7L20.4,4z M6,22v-3.6l10-10l3.6,3.6l-10,10H6z"
      />
    </svg>
  );
};

export default Pen;
